import { useTranslation } from 'react-i18next';
import CategoryCard from './CategoryCard';

function CategoriesSection({ categories }) {
  const { t } = useTranslation();

  return (
    <section className="categories container" id="categories">
      <div className="section-label">
        <span>{t('sections.categories')}</span>
        <span>02 / 05</span>
      </div>
      <div className="cat-grid">
        {categories.map((category, index) => (
          <CategoryCard
            category={category}
            index={index}
            key={category.documentId || category.id}
          />
        ))}
      </div>
    </section>
  );
}

export default CategoriesSection;
